import { Button, HFlow, Tooltip } from 'bold-ui'

interface PrescricaoMedicamentoFormActionButtonsProps {
  isRenovacao: boolean
  onReset: () => void
  onSubmit: () => void
  tooltipText?: string
}

export const PrescricaoMedicamentoFormActionButtons = (
  props: Readonly<PrescricaoMedicamentoFormActionButtonsProps>
) => {
  const { isRenovacao, onReset, onSubmit, tooltipText } = props
  return (
    <HFlow justifyContent='flex-end'>
      <Tooltip text={tooltipText}>
        <Button onClick={onReset} size='small' data-cy='LimparCamposButton' disabled={isRenovacao}>
          Limpar campos
        </Button>
      </Tooltip>
      <Button kind='primary' size='small' onClick={onSubmit} data-cy='SalvarButton'>
        Salvar prescrição
      </Button>
    </HFlow>
  )
}
